"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HouseManager = void 0;
const implementations_1 = require("./implementations");
class HouseManager {
    constructor(config) {
        this._community = implementations_1.CommunityHouse.for(config);
        this._all = new Map([[this._community.type, this._community]]);
    }
    /**
     * Returns a `House` instance for the provided chain configuration
     * @param config The chain configuration
     */
    static for(config) {
        return new HouseManager(config);
    }
    /**
     * Community house utilities
     */
    get community() {
        return this._community;
    }
    /**
     * Get a house utility class instance
     * @param type The house type
     */
    get(type) {
        if (!this._all.has(type)) {
            throw new Error(`Unknown house type: ${type}`);
        }
        return this._all.get(type);
    }
    /**
     * @notice Get the implementation contract address for the provided house type
     * @param type The house type
     */
    getImpl(type) {
        return this.get(type).impl;
    }
    /**
     * @notice Get a house contract instance
     * @param type The house type
     * @param address The house address
     */
    getContract(type, address) {
        return this.get(type).getContract(address);
    }
    /**
     * @notice ABI-encode the provided house configuration
     * @param house The house information
     */
    encode(house) {
        return this.get(house.houseType).encode(house.config);
    }
}
exports.HouseManager = HouseManager;
